import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, unref as _unref } from "vue"

const _hoisted_1 = { class: "flex space-x-5" }
const _hoisted_2 = {
  key: 1,
  class: "animate-spin m-auto h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "flex flex-col w-full space-y-2 my-auto" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex text-white text-xl font-medium" }, "Photo I.D Card", -1)
const _hoisted_8 = {
  key: 0,
  class: "text-brand-light-gray text-base"
}
const _hoisted_9 = {
  key: 1,
  class: "text-brand-light-gray text-base"
}

import {isPlatform, useIonRouter} from "@ionic/vue";
import {computed, onMounted, PropType, ref} from "vue";
import ApiService from "@/services/api/apiService";
import useCamera from "@/composables/useCamera";
import {CameraResultType, CameraSource} from "@capacitor/camera";
import {AccountType} from "@/definitions/AccountType";
import {UserBasicInformationInterface} from "@/interfaces/UserBasicInformationInterface";
import {Observable, ObservableEvent} from "@/services/observable/Observable";


export default /*#__PURE__*/_defineComponent({
  __name: 'VerifyIdCard',
  props: {
  user: {
    type: Object as PropType<UserBasicInformationInterface>,
    required: true
  }
},
  setup(__props) {



const ionRouter = useIonRouter()
const busy = ref(true)
const status = ref()

const photo = ref()

const props = __props

onMounted(async () => {
  status.value = await ApiService.User().getVerificationStatus()
  if (status.value.id_card_photo) photo.value = status.value.id_card_photo
  busy.value = false
})

const isImageUrl = computed(()=>{
  if (!photo.value) return
  return photo.value.includes('http')
})

const awaitingVerification = computed(()=>{
  if (!status.value) return
  return status.value.submitted_at
})

const choosePhoto = async () => {

  if (busy.value || status.value.submitted_at) return

  try {

    const image = await useCamera(CameraSource.Photos, CameraResultType.Base64)
    busy.value = true
    photo.value = undefined
    if (image && image.base64String) await ApiService.User().setIdCardPhoto(image.base64String)
    photo.value = image.base64String
    Observable.emit(ObservableEvent.VerificationStatusChanged)
  } catch (e) {
    busy.value = false
  } finally {
    busy.value = false
  }
}

const goBack = async () => {
  await ionRouter.back()
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: choosePhoto,
      class: "flex flex-col items-center space-y-4"
    }, [
      _createElementVNode("div", {
        style: _normalizeStyle([
                  !isImageUrl.value ? `background-image: url('data:image/jpeg;base64,${photo.value}')` : `background-image: url('${photo.value}')`
              ]),
        class: _normalizeClass([{
              'border-2' : !photo.value
            }, "flex w-32 h-32 rounded-xl bg-cover bg-center border-brand-light-gray border-dashed"])
      }, [
        (!busy.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([{ 'opacity-0' : photo.value}, "text-brand-light-gray m-auto text-center text-sm"])
            }, "Choose photo ", 2))
          : _createCommentVNode("", true),
        (busy.value)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_5))
          : _createCommentVNode("", true)
      ], 6)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      (__props.user.account_type === _unref(AccountType).Individual)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Take a clear photo of Your Photo I.D card making sure that the photo is not obscured and all 4 corners are visible."))
        : _createCommentVNode("", true),
      (__props.user.account_type === _unref(AccountType).Joint)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Take a clear photo of ALL users Photo I.D cards in the relationship, making sure that the photo is not obscured and all 4 corners are visible."))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})